(function () {
	var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0];
 
	var windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
	var windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	var mobileLimit = 671;
	var tabletLimit = 1023;
	var desktopLimit = 1024;
	var isMobileContext = (windowWidth < mobileLimit) ? true : false;
	var isMobileTabletContext = (windowWidth <= tabletLimit) ? true : false;
	var isTabletContext = (windowWidth < tabletLimit) && (windowWidth > mobileLimit)? true : false;
  
	var isPrevMobileContext = isMobileContext;
	var isPrevMobileTabletContext = isMobileTabletContext;
	var isPrevTabletContext = isTabletContext;
  
  
	// No action on empty links :
	document.querySelectorAll('a[href="#"]').forEach(function(elt){
		elt.addEventListener('click',function(e) {
			e.preventDefault();
		});
	});
	var trace = document.querySelector('#trace');
  function traceIt(what) {
    if(trace) {
      trace.innerHTML += '<br>'+what;
    }
  }
	//------------DOMLOAD		
	document.addEventListener("DOMContentLoaded", function () {
    
		//flag body for safari
		if(XXL.isSafari){
			document.body.classList.add('safari');
		}
    
    function calculateVhForMobiles() {
      //console.log("calculateVhForMobiles()!");
      var wh = w.innerHeight||e.clientHeight||g.clientHeight;
      var vh = wh * .01;
      setTimeout(function() {
      document.documentElement.style.setProperty('--vh', vh + 'px');
      //console.log("vh: ", vh);
      }, 0);
    }
    calculateVhForMobiles();
    
    // mise en forme menus top-nav
    //var menuClasses = ['theatre', 'cinema', 'librairie', 'expos', 'restau', 'ecole', 'lucernaire']; 
    var menuItems = document.querySelectorAll('.main-header .navigations .menu-item');
    if(menuItems.length) {
      menuItems.forEach(function(elt, index) {
        var lien = elt.querySelector('a');
        var texte = lien.textContent;
        var wrapper = document.createElement('span');
        wrapper.innerText = texte;
        lien.textContent = '';
        var picto = document.createElement('div');
        picto.classList.add('picto');
        picto.innerHTML = '<svg viewBox="0 0 18 20"><use xlink:href="#svg-lucernaire-picto"></use></svg>';
        lien.appendChild(picto);
        lien.appendChild(wrapper);
        //// TODO ajouter classe au li avec WP
        //elt.classList.add(menuClasses[index]);
        //elt.classList.add('active-trail');
      });
    }
    
    //init smooth locomotive scroll
    var locoScroll = false;
    function initLocomotive() {
      /*
      if(!isMobileTabletContext && !XXL.isSafari) {
        if(locoScroll) {
          locoScroll.destroy();
        }
        locoScroll = new LocomotiveScroll({
          el: document.querySelector('[data-scroll-container]'),
          smooth: true
        });
        locoScroll.on('scroll', updateLocoBody);
        setTimeout(function(){
          locoScroll.update();
        }, 500);
      }
      else {
        if(locoScroll) {
          locoScroll.destroy();
          locoScroll = false;
          //locomotive ne nettoie pas correctement son plugin au destroy !!!
          document.querySelector('[data-scroll-container]').style.transform = 'none';
          document.querySelectorAll('[data-scroll]').forEach(function(elt) {
            elt.style.transform = 'none';
          });
        }
      }
      */
    }
    
    //.anchor-link (see event delegation)
    function anchorFunk(el) {
      var delta = (el.getAttribute('data-offset'))  ? parseInt(el.getAttribute('data-offset'), 10) : 0;
      var obj = document.querySelector(el.getAttribute('href'));
      if(locoScroll) {
        var options = {offset:delta};
        locoScroll.scrollTo(obj, options);
      }
      else {
        window.scrollTo({
          top: obj.offsetTop + delta,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
    
    var docuLastScroll = 0;
    function updateLocoBody(obj) {
			var currentScroll = obj.scroll.y;
      //console.log(">>>>>>>>>>>> obj: ", obj);
      //console.log(">>>>>>>>>>>> ");
      //console.log("currentScroll: ", currentScroll);
      //console.log("docuLastScroll: ", docuLastScroll);
			var limit = (isMobileContext) ? 10 : 10;
			if(currentScroll == 0){
				// nothing to do
			}
			else if(currentScroll >= docuLastScroll){
				//We go down
				//limit = 250;
				document.body.classList.remove('goingup');
				document.body.classList.add('goingdown');
			}
			else{
				// We go up
				//limit = 250;
				document.body.classList.remove('goingdown');
				document.body.classList.add('goingup');
			}
			if(currentScroll <= limit){
				document.body.classList.remove('scrolled');
			}
			else{
				if(!document.body.classList.contains('scrolled')){
          document.body.classList.add('scrolled');
				}
			}
			docuLastScroll = currentScroll;
      //surveiller hey
      if(typeof obj.currentElements['hey'] === 'object') {
        var progress = obj.currentElements['hey'].progress;
        //console.log(obj.currentElements['hey']);
        // ouput log example: 0.34
        // gsap example : myGsapAnimation.progress(progress);
      }
		}
    //body scrolling state
		//var docuLastScroll;
		function updateBody() {
			var currentScroll = w.pageYOffset;
      //console.log("**********");
      //console.log("currentScroll: ", currentScroll);
      //console.log("docuLastScroll: ", docuLastScroll);
			var limit = 10
			var mainHeader = document.querySelector('.main-header');
			if(currentScroll == 0){
				// nothing to do
			}
      
			if(currentScroll > docuLastScroll){
				//We go down
				limit = 10;
				document.body.classList.remove('goingup');
				document.body.classList.add('goingdown');
			}
			else{
				// We go up
				limit = 10;
				document.body.classList.remove('goingdown');
				document.body.classList.add('goingup');
			}
      
			if(currentScroll <= limit){
				document.body.classList.remove('scrolled');
			}
			else{
				if(!document.body.classList.contains('scrolled')){
					document.body.classList.add('scrolled');
				}
			}
			docuLastScroll = currentScroll;
      //
      //console.log("docuLastScroll");
      calculateVhForMobiles();
		}
		docuLastScroll = w.pageYOffset;
		updateBody();
		w.addEventListener('scroll', updateBody);
    /**
     * Like jQuery's slideDown/slideUp function - uses CSS3 transitions
     * @param  {Node} elem Element to show and hide
     */
    function slideDown(elem) {
      var h = 0;
      //console.log("elem.children: ", elem.children);
      elem.children.forEach(function(elt){
       var margins = parseInt(window.getComputedStyle(elt).getPropertyValue('margin-top')) + parseInt(window.getComputedStyle(elt).getPropertyValue('margin-bottom'))
        h = h + elt.getBoundingClientRect().height + margins;
      });
      elem.style.maxHeight = h + 'px';
    }
    function slideUp(elem) {
      var h = elem.getAttribute('data-height') || 0;
      elem.style.maxHeight = h;
    }
    //open more //see event-delegation
    function openMore(el) {
      var cib = el.parentNode.querySelector('.js-more-cib');
      var mask = cib.querySelector('.mask');
      var textOn = el.querySelector('.rolloff > span');
      var textOff = el.querySelector('.rollon > span');
      if(el.classList.contains('open')) {
        slideUp(cib);
        mask.classList.remove('hidden');
        el.classList.remove('open');
        textOff.innerText = el.getAttribute('data-open');
        textOn.innerText = el.getAttribute('data-open');
        if(locoScroll) {
          setTimeout(function(){
            locoScroll.update();
          }, 500);
        }
      }
      else {
        slideDown(cib);
        mask.classList.add('hidden');
        el.classList.add('open');
        textOff.innerText = el.getAttribute('data-close');
        textOn.innerText = el.getAttribute('data-close');
        if(locoScroll) {
          setTimeout(function(){
            locoScroll.update();
          }, 500);
        }
      }
    }
    //more action only if ul.height > 170px
    function moreAction() {
      var moreCib = document.querySelector('.spectacle-distribution ul');
      if(moreCib) {
        var h = parseInt(window.getComputedStyle(moreCib).getPropertyValue('height'), 10);
        if(h <= 170) {
          //hide mask
          document.querySelector('.spectacle-distribution .mask').style.display = 'none';
          //hide btn
          document.querySelector('.spectacle-distribution .js-more').style.display = 'none';
          //update locomotive scroll if exists
          if (locoScroll) {
            locoScroll.update();
          }
        }
      }
    }
    
    /*
    //parallax for Safari !
    function initRegalParallax(){
      var regalParallax = document.querySelectorAll('.js-regal-parallax');
      if(regalParallax && XXL.isSafari){
        for(var i=0; i<regalParallax.length; i++){
          regalParallax[i].regalParallax = new RegalParallax(regalParallax[i]);
        }
      }
    }
    function destroyRegalParallax(){
      var regalParallax = document.querySelectorAll('.js-regal-parallax');
      if(regalParallax && XXL.isSafari){
        for(var i=0; i<regalParallax.length; i++){
          if(regalParallax[i].regalParallax) {
            regalParallax[i].regalParallax.destroy();
          }
        }
      }
    }
    */
    
    //menu hamburger
    if(document.querySelector('.main-header .hamburger')) {
      document.querySelector('.main-header .hamburger').addEventListener('click', function (e) {
        e.preventDefault();
        if(e.currentTarget.classList.contains('active')) {
          //close
          e.currentTarget.classList.remove('active');
          //document.querySelector('.main-nav-mask').classList.remove('open');
          document.querySelector('.navigations').classList.remove('open');
          document.querySelector('.navigations').classList.add('closing');
          document.querySelector('body').classList.remove('no-overflow');
          document.querySelector('.navigations').addEventListener(transitionEvent, navigationsCallback);
          //document.querySelector('.page-content').classList.remove('mobile-nav-active');
          //document.querySelector('.main-header').classList.remove('mobile-nav-active');
          //document.querySelector('.main-footer').classList.remove('mobile-nav-active');
          //close opened ssrub // not needed here
          /*
          document.querySelectorAll('.main-nav-list > ul > li.expanded .plus').forEach(function(elt){
            elt.classList.remove('active');
            elt.innerHTML = '+';
          });
          document.querySelectorAll('.main-nav-list > ul > li.expanded .ssrub').forEach(function(elt){
            elt.classList.remove('active');
            slideUp(elt);
          });
          */
        }
        else {
          //open
          e.currentTarget.classList.add('active');
          //document.querySelector('.main-nav-mask').classList.add('open');
          document.querySelector('.navigations').classList.add('open');
          document.querySelector('body').classList.add('no-overflow');
          //document.querySelector('.page-content').classList.add('mobile-nav-active');
          //document.querySelector('.main-header').classList.add('mobile-nav-active');
          //document.querySelector('.main-footer').classList.add('mobile-nav-active');
        }
      });
		}
    
    function navigationsCallback(event) {
      document.querySelector('.navigations').removeEventListener(transitionEvent, navigationsCallback);
			document.querySelector('.navigations').classList.remove('closing');
    }
    
    //tiny-sliders
    //sliders no-loop active / desactive buttons prev / next
    function sliderNoLoopTransitionEnd(info, eventName){
      if(info.index === 0){
        info.prevButton.classList.add('inactive');
      }
      else{
        info.prevButton.classList.remove('inactive');
      }
      if(info.index + info.items >= info.slideItems.length){
        info.nextButton.classList.add('inactive');
      }
      else{
        info.nextButton.classList.remove('inactive');
      }
    };
    //sliders prevent click on nav while moving
    function preventSliderNav(info, eventName){
      //console.log("preventSliderNav(), info: ", info);
      var slider = info.container;
      var outer = slider.closest('.tns-outer');
      var nav = outer.querySelector('.tns-nav');
      var controls = outer.querySelector('.tns-controls');
      if(nav){
        nav.classList.add('no-event');
      }
      if(controls){
        controls.classList.add('no-event');
      }
    };
    function allowSliderNav(info, eventName){
      //console.log("info: ", info);
      var slider = info.container;
      var outer = slider.closest('.tns-outer');
      var nav = outer.querySelector('.tns-nav');
      var controls = outer.querySelector('.tns-controls');
      setTimeout(function(){
        if(nav){
          nav.classList.remove('no-event');
        }
        if(controls){
          controls.classList.remove('no-event');
        }
      }, 500);
    };
    function uploadLoco(info, eventName) {
      //console.log("info: ", info);
      //console.log("uploadLoco()");
      if(locoScroll) {
        locoScroll.update();
      }
    };
    function playPauseSlider(elt, on, from){
      //console.log("playPauseSlider(), from: ", from);
      if(on){
        if(elt.slider && elt.paused) {
          //traceIt("playPauseSlider(), elt.slider.play");
          //console.log("playPauseSlider(), play");
          elt.slider.play();
          elt.paused = false;
        }
      }
      else{
        if(elt.slider) {
          //traceIt("playPauseSlider(), elt.slider.pause");
          //console.log("playPauseSlider(), pause");
          elt.slider.pause();
          elt.paused = true;
        }
      }
    };
    //default-slider
    function initDefaultSliders(){
      var defaultSliders = document.querySelectorAll('.default-slider');
      if(defaultSliders){
        defaultSliders.forEach(function(elt){
          if(!elt.slider /*&& elt.querySelectorAll('.default-slide').length > 1*/){
            var obj = {};
            //obj.mode = 'gallery';
            var autoplay = ( elt.getAttribute('data-autoplay') && elt.getAttribute('data-autoplay') === 'true' ) ? true : false;
            obj.container = elt;
            obj.items = 1;
            obj.slideBy = 1;
            obj.autoHeight = true;
            obj.speed = 600;
            obj.gutter = 0;
            obj.loop = true;
            obj.controls = true;
            obj.nav = true;
            obj.autoplay = autoplay
            obj.autoplayTimeout = 4000;
            //obj.autoplayText = ["▶","❚❚"];
            obj.arrowKeys = true;
            obj.edgePadding = 0;
            //obj.responsive = {651: {"nav": true}};
            //console.log("obj: ", obj);
            elt.slider = tns(obj);
            if(elt.slider) {
              //prevent buttons while moving
              elt.slider.events.on('transitionStart', preventSliderNav);
              elt.slider.events.on('transitionEnd', allowSliderNav);
              if(obj.autoHeight === true) {
                elt.slider.events.on('transitionEnd', uploadLoco);
              }
              //pause autoplay when out of sight / play when in sight
              if(autoplay) {
                setTimeout(function(){
                  //traceIt("declare XXL.Observer");
                  var threshold = 0;
                  (elt.closest('.slider') === document.querySelector('body.home .slider:first-child'))
                    ? threshold = (isMobileTabletContext) ? .0375 : .1
                    : threshold = (isMobileTabletContext) ? .1 : .1;
                  XXL.XLObserver(elt, playPauseSlider, threshold, false);
                }, 0);
              }
              //insert svg in buttons
              setTimeout(function(){
                //console.log("insert svg in buttons!!!");
                var arrow_html = '<svg viewBox="0 0 15.999 12.828"><use xlink:href="#svg-arrow-left"></use></svg>';
                var bg_html = '<svg viewBox="0 0 200 222"><use xlink:href="#svg-slider-bg"></use></svg>';
                var buttons = elt.closest('.tns-outer').querySelectorAll('.tns-controls button');
                //console.log("elt: ", elt);
                //console.log("elt.closest('.tns-outer'): ", elt.closest('.tns-outer'));
                //console.log("buttons: ", buttons);
                if(buttons.length) {
                  buttons.forEach(function(bt) {
                    var arrow = document.createElement('div');
                    arrow.classList.add('picto');
                    arrow.innerHTML = arrow_html;
                    bt.appendChild(arrow);
                    var bg = document.createElement('div');
                    bg.classList.add('bg');
                    bg.innerHTML = bg_html;
                    bt.appendChild(bg);
                  });
                }
              }, 800);
            }
          }
        });
      }
    };
    function updateDefaultSliders(){
      var defaultSliders = document.querySelectorAll('.default-slider');
      if(defaultSliders){
        defaultSliders.forEach(function(elt){
          if(elt.slider) {
            elt.slider.updateSliderHeight();
          }
        });
      }
    };
    
    //images-slider
    function initImagesSliders(){
      var imagesSliders = document.querySelectorAll('.images-slider');
      if(imagesSliders){
        imagesSliders.forEach(function(elt){
          if(!elt.slider /*&& elt.querySelectorAll('img').length > 1*/){
            var obj = {};
            var autoplay = ( elt.getAttribute('data-autoplay') && elt.getAttribute('data-autoplay') === 'true' ) ? true : false;
            obj.container = elt;
            obj.items = 1;
            obj.slideBy = 1;
            obj.autoHeight = false;
            obj.speed = 600;
            obj.gutter = 0;
            obj.loop = true;
            obj.controls = true;
            obj.nav = true;
            obj.autoplay = autoplay;
            obj.autoplayTimeout = 3000;
            //obj.autoplayText = ["▶","❚❚"];
            obj.arrowKeys = true;
            obj.edgePadding = 0;
            //obj.responsive = {651: {"nav": true}};
            //console.log("obj: ", obj);
            elt.slider = tns(obj);
            if(elt.slider) {
              //prevent buttons while moving
              elt.slider.events.on('transitionStart', preventSliderNav);
              elt.slider.events.on('transitionEnd', allowSliderNav);
              if(obj.autoHeight === true) {
                elt.slider.events.on('transitionEnd', uploadLoco);
              }
              //pause autoplay when out of sight / play when in sight
              if(autoplay) {
                setTimeout(function(){
                  //traceIt("declare XXL.Observer");
                  var threshold = (isMobileTabletContext) ? .4 : .1;
                  XXL.XLObserver(elt, playPauseSlider, threshold, false);
                }, 1500);
              }
            }
          }
        });
      }
    };
    
    //press-slider
    function initPressSliders(){
      var pressSliders = document.querySelectorAll('.press-slider');
      if(pressSliders){
        pressSliders.forEach(function(elt){
          if(!elt.slider /*&& elt.querySelectorAll('.press-slide').length > 1*/){
            var obj = {};
            obj.container = elt;
            obj.items = 1;
            obj.slideBy = 1;
            obj.autoHeight = true;
            obj.speed = 600;
            obj.gutter = 0;
            obj.loop = true;
            obj.controls = true;
            obj.nav = false;
            obj.autoplay = false;
            //obj.autoplayTimeout = 0;
            //obj.autoplayText = ["▶","❚❚"];
            obj.arrowKeys = true;
            obj.edgePadding = 0;
            //console.log("obj: ", obj);
            elt.slider = tns(obj);
            if(elt.slider) {
              //prevent buttons while moving
              elt.slider.events.on('transitionStart', preventSliderNav);
              elt.slider.events.on('transitionEnd', allowSliderNav);
              if(obj.autoHeight === true) {
                elt.slider.events.on('transitionEnd', uploadLoco);
              }
              //insert svg in buttons
              setTimeout(function(){
                var arrow_html = '<svg viewBox="0 0 15.999 12.828"><use xlink:href="#svg-arrow-left"></use></svg>';
                var buttons = elt.closest('.tns-outer').querySelectorAll('.tns-controls button');
                if(buttons.length) {
                    buttons.forEach(function(bt) {
                      var arrow = document.createElement('div');
                      arrow.classList.add('picto');
                      arrow.innerHTML = arrow_html;
                      bt.appendChild(arrow);
                    });
                }
              }, 500);
            }
          }
        });
      }
    };
    //slider-events
    function initEventsSliders(){
      var eventsSliders = document.querySelectorAll('.slider-events');
      if(eventsSliders){
        eventsSliders.forEach(function(elt){
          if(!elt.slider /*&& elt.querySelectorAll('.slide').length > 1*/){
            var nbItemsDesktop = (elt.classList.contains('items-3')) ? 3 : 4;
            var obj = {};
            obj.container = elt;
            obj.items = 1;
            obj.slideBy = 1;
            obj.autoHeight = false;
            obj.speed = 600;
            obj.gutter = 54;
            obj.loop = true;
            obj.controls = true;
            obj.nav = false;
            obj.autoplay = false;
            //obj.autoplayTimeout = 0;
            //obj.autoplayText = ["▶","❚❚"];
            obj.arrowKeys = true;
            obj.edgePadding = 0;
            obj.responsive = {
              768: {
                items: 2,
                slideBy: 2
              },
              1024: {
                items: nbItemsDesktop,
                slideBy: 4
              }
            };
            elt.slider = tns(obj);
            if(elt.slider) {
              //prevent buttons while moving
              elt.slider.events.on('transitionStart', preventSliderNav);
              elt.slider.events.on('transitionEnd', allowSliderNav);
              if(obj.autoHeight === true) {
                elt.slider.events.on('transitionEnd', uploadLoco);
              }
              //insert svg in buttons
              setTimeout(function(){
                var arrow_html = '<svg viewBox="0 0  35.998 26.83"><use xlink:href="#svg-arrow-left-thin"></use></svg>';
                var buttons = elt.closest('.tns-outer').querySelectorAll('.tns-controls button');
                if(buttons.length) {
                    buttons.forEach(function(bt) {
                      var arrow = document.createElement('div');
                      arrow.classList.add('picto');
                      arrow.innerHTML = arrow_html;
                      bt.appendChild(arrow);
                    });
                }
              }, 500);
            }
          }
        });
      }
    };
    
    //accordions faq 
    function initAccordions() {
      var acc = document.querySelectorAll('.accordion-tab');
      if(acc){
        acc.forEach(function(elt){
          var opener = elt.querySelector('.accordion-opener');
          opener.addEventListener('click', function(e){
            e.preventDefault();
            var that = e.currentTarget;
            var tab = that.parentNode.querySelector('.tab-content');
            var accordion = that.closest('.accordion-tab');
            if(that.classList.contains('open')){
              that.classList.remove('open');
              that.setAttribute('aria-expanded', false);
              tab.setAttribute('aria-hidden', true);
              accordion.classList.remove('open');
              slideUp(tab);
              //update locomotive scroll if exists
              setTimeout(function() {
                if (locoScroll) {
                  locoScroll.update();
                }
              }, 500);
            }
            else{
              that.classList.add('open');
              that.setAttribute('aria-expanded', true);
              tab.setAttribute('aria-hidden', false);
              accordion.classList.add('open');
              slideDown(tab);
              //update locomotive scroll if exists
              setTimeout(function() {
                if (locoScroll) {
                  locoScroll.update();
                }
              }, 500);
            }
          });
        });
      }
    };
    
    //filters spectacles
    var ajax_loader_html = '<div class="loader"><div class="sk-circle visible"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div></div>';
    function initFilters() {
      //desktop rendre visible btn filtrer quand #filters sort du champs de vision
      var filters = document.querySelector('#filters');
      if(filters) {
        var stickyBtnCont = document.querySelector('#sticky-btn');
        var resetBtn = filters.querySelector('.filters-reset');
        /*
        var filtersObs = false;
        if(filters && !isMobileTabletContext) {
          if(!filtersObs){
            filtersObs = XXL.XLObserver(filters, revealStickyBtn, .25, false);
          }
          var stickyBtn = stickyBtnCont.querySelector('.btn');
          //add anchor-link class
          stickyBtn.classList.add('anchor-link');
        }
        */
        //mobile afficher filtres quand click stickyBtn
        if(filters && isMobileTabletContext) {
          if(stickyBtnCont) {
            var stickyBtn = stickyBtnCont.querySelector('.btn');
            //remove anchor-link class
            stickyBtn.classList.remove('anchor-link');
            //action
            stickyBtn.addEventListener('click', function(e) {
              e.preventDefault();
              filters.classList.add('open');
              document.querySelector('body').classList.add('no-overflow');
            });
            var closeFiltersBtn = filters.querySelector('.filters-close');
            closeFiltersBtn.addEventListener('click', function(e) {
              e.preventDefault();
              filters.classList.remove('open');
              document.querySelector('body').classList.remove('no-overflow');
            });
          }
        }
        //reset btn
        resetBtn.addEventListener('click', resetFilters);
        var inputs = filters.querySelectorAll('input');
        inputs.forEach(function(inp) {
          inp.addEventListener('input', checkInputsValues);
        });
        //more-results
        
        var moreBtn = document.querySelector('#js-more-results');
        //no-more-results !
        if(document.querySelector('#end')) {
          //remove btn
          if(moreBtn) {
            moreBtn.remove();
          }
          //update locomotive scroll if exists
          if (locoScroll) {
            locoScroll.update();
          }
        }
        else {
          if(moreBtn) {
            moreBtn.addEventListener('click', loadMoreResults);
          }
        }
        //applyFilters mobile 
        document.querySelector('#js-apply-filters').addEventListener('click', loadFilteredResults);
      }
    }
   /* var stickyBtnCont = document.querySelector('#sticky-btn');
    function revealStickyBtn(elt, on, from){
      if(on){
        stickyBtnCont.classList.remove('visible');
      }
      else{
        stickyBtnCont.classList.add('visible');
      }
    };*/
    function checkInputsValues(e) {
      showReset = false;
      //check checkboxes
      filters.querySelectorAll('.filter-checkbox').forEach(function(elt){
        if(elt.querySelectorAll('input:checked').length){ 
          showReset = true;
        }
      });
      //check radios
      filters.querySelectorAll('.filter-radio').forEach(function(elt){
        if(elt.querySelectorAll('input:checked').length){ 
          showReset = true;
        }
      });
      //check date
      filters.querySelectorAll('input[type=date]').forEach(function(elt){
        if(elt.value !== ''){ 
          showReset = true;
        }
      });
      if(showReset) {
        filters.querySelector('.filters-reset').classList.add('visible');
        //active btn
        document.querySelector('#js-apply-filters').classList.remove('inactive');
      }
      else {
        filters.querySelector('.filters-reset').classList.remove('visible');
        //active btn
        document.querySelector('#js-apply-filters').classList.add('inactive');
      }
      if(!isMobileTabletContext) {
        // load new content each time a filter is changed...!
        loadFilteredResults();
      }
    }
    function resetFilters() {
      var datas = new FormData(document.querySelector('#filters-form'));
      document.querySelector('#filters-form').reset();
      //date special design reset
      filters.querySelectorAll('.input-date').forEach(function(elt){
        var resetDate = elt.querySelector('.fake-date-reset');
        triggerEvent(resetDate, 'click');
      });
      //mobile ajax
      if(isMobileTabletContext) {
        triggerEvent(document.querySelector('#js-apply-filters'), 'click');
      }
      //inactive btn
      document.querySelector('#js-apply-filters').classList.add('inactive');
    }
    function closeFilters() {
       filters.classList.remove('open');
       document.querySelector('body').classList.remove('no-overflow');
    }
    var resultsPagination = 1;
    function loadMoreResults() {
      var loader = document.querySelector('#js-more-loader');
      var formulaire = document.querySelector('#filters-form');
      var params = new FormData(formulaire);
      resultsPagination++;
      params.append('pagination', resultsPagination);
      //console.log("params: ", params);
      //XXL.ajaxCall: function(url, params, method, callback)
      loader.classList.add('visible');
      var btn = document.querySelector('#js-more-results');
			btn.style.display = 'none';
      var url = btn.getAttribute('data-action');
			var method = formulaire.getAttribute('method');
			setTimeout(function(){
        XXL.ajaxCall(url, params, method, loadMoreResultsCallback);
      }, 500);
    }
    function loadMoreResultsCallback(response) {
      var newList = document.createElement('div');
      newList.classList.add('results');
      newList.innerHTML = response;
      //console.log("response: ", response);
      var results = document.querySelector('#js-results');
      var before = results.querySelector('#js-actions');
      //console.log("before: ", before);
      results.insertBefore(newList, before);
      var loader = document.querySelector('#js-more-loader');
      loader.classList.remove('visible');
      var btn = document.querySelector('#js-more-results');
			btn.style.display = '';
      //no-more-results !
      if(newList.querySelector('#end')) {
        //remove btn
        btn.remove();
      }
      //update locomotive scroll if exists
      if (locoScroll) {
        locoScroll.update();
      }
    }
    function loadFilteredResults() {
      var formulaire = document.querySelector('#filters-form');
      var params = new FormData(formulaire);
      resultsPagination = 1;
      params.append('pagination', resultsPagination);
      //XXL.ajaxCall: function(url, params, method, callback)
      var url = formulaire.getAttribute('action');
			var method = formulaire.getAttribute('method');
      document.querySelector('#js-all-results').classList.add('ajax-loading');
      document.querySelector('#js-all-results').innerHTML = ajax_loader_html;
			setTimeout(function(){
        XXL.ajaxCall(url, params, method, loadFilteredResultsCallback);
      }, 500);
    }
    function loadFilteredResultsCallback(response) {
      //// TODO gérer no-results !
      var newResults = document.createElement('div');
      newResults.classList.add('all-results');
      newResults.innerHTML = response;
      //console.log("response: ", response);
      var cib = document.querySelector('#js-all-results');
      cib.classList.remove('ajax-loading');
      cib.innerHTML = response;
      //close mobile panel
      closeFilters();
      if(isMobileTabletContext) {
        var delta = 88;
        window.scrollTo({
          top: document.querySelector('#js-all-results').offsetTop - delta,
          left: 0,
          behavior: 'smooth'
        });
      }
      //update locomotive scroll if exists
      if (locoScroll) {
        locoScroll.update();
      }
      //initFilters();
      initApp();
    }
    //fin filters
    
    // text-visu section gestion largeur et position visu (impossible à gérer en pure CSS)
		function setVisuWidth(){
      windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
			windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
			isMobileContext = (windowWidth < mobileLimit) ? true : false;
			isMobileTabletContext = (windowWidth < tabletLimit) ? true : false;
			isTabletContext = (windowWidth < tabletLimit) && (windowWidth > mobileLimit)? true : false;
			if(document.querySelectorAll('.images-desc-js').length){
				document.querySelectorAll('.images-desc-js').forEach(function(elt){
          if(!isMobileTabletContext){
						setTimeout(function(){
							if(elt.querySelector('.image-full-width')){
								var contentWidth = parseFloat(window.getComputedStyle(elt).getPropertyValue('width'));
								var totalWidth = document.documentElement.clientWidth;
								var space = ((totalWidth - contentWidth) / 2);
								var visuInitWidth = elt.querySelector('.images') ? parseFloat(window.getComputedStyle(elt.querySelector('.images')).getPropertyValue('width')) : 0;
								var visuNewWidth = visuInitWidth + space;
								elt.querySelector('.image-full-width').style.width = visuNewWidth + 'px';
                if(elt.classList.contains('images-left')){
                  elt.querySelector('.image-full-width').style.marginLeft = space * -1 + 'px';
                }
                if(elt.classList.contains('images-right')){
                  elt.querySelector('.image-full-width').style.marginRight = space * -1 + 'px';
                }
                // calage hauteur minimum .desc selon hauteur image
                /* no need for Lucernaire because align-items: center
                var imageH = parseFloat(window.getComputedStyle(elt.querySelector('.images')).getPropertyValue('height'));
                var descMinH = imageH - 100;
                elt.querySelector('.desc').style.minHeight = descMinH + 'px';
                */
							}
						}, 0);
          }
          else{
						setTimeout(function(){
              elt.querySelector('.image-full-width').style.width = '';
              elt.querySelector('.image-full-width').style.marginLeft = '';
              elt.querySelector('.image-full-width').style.marginRight = '';
              elt.querySelector('.desc').style.minHeight = '';
            }, 0);
          }
				});
			}
		};
    window.addEventListener('resize', function() {
			setVisuWidth();
		});
    // fin text-visu section gestion largeur et position visu
    
		//event delegation
		document.addEventListener('click', docEvent);
		function docEvent(e) {
			//console.log("e.target: ", e.target);
			//playVideo
			if (e.target.closest('.play-video')) {
				e.preventDefault();
				XXL.playVideo(e.target.closest('.play-video'));
			}
			//openPopin
			if (e.target.closest('.open-popin')) {
				e.preventDefault();
				XXL.openPopin(e.target.closest('.open-popin').getAttribute('href') || e.target.closest('.open-popin').getAttribute('data-popin-id'));
			}
      //anchor-links
      if (e.target.closest('.anchor-link')) {
				e.preventDefault();
				anchorFunk(e.target.closest('.anchor-link'));
			}
      //back-top
      if (e.target.closest('.back-top')) {
        e.preventDefault();
        scrollToTop();
      }
      //openMore(el)
      if (e.target.closest('.js-more')) {
        e.preventDefault();
        openMore(e.target.closest('.js-more'));
      }
      
		}
		
		//cookies acceptLucernaireCookies
		var lucernaireCookies = 'acceptLucernaireCookies';
		//XXL.eraseCookie(lucernaireCookies); //////////////////////////////// ligne à commenter quand process cookies validé
		var acceptCookies = XXL.readCookie(lucernaireCookies);
    var cookieSection = document.querySelector('#cook-panel');
    if(cookieSection){
      if(!acceptCookies){
        cookieSection.classList.add('visible');
        cookieSection.querySelector('#cook-accept').addEventListener('click', function(e){
          e.preventDefault();
          XXL.createCookie(lucernaireCookies, 'accept');
          cookieSection.classList.remove('visible');
        });
        cookieSection.querySelector('#cook-deny').addEventListener('click', function(e){
          e.preventDefault();
          XXL.createCookie(lucernaireCookies, 'deny');
          cookieSection.classList.remove('visible');
        });
      }
      else {
        cookieSection.remove();
      }
		}
		
		function animRevealCallback(elt, on, from){
      if(on){
        elt.classList.add('revealed');
      }
      else{
        elt.classList.remove('revealed');
        if(from == 'top'){
          elt.classList.add('top');
        }
        else{
          elt.classList.remove('top');
        }
      }
    };
    function initAnimReveal(){
      /*if(!locoScroll) {
        document.querySelectorAll('.js-reveal').forEach(function(elt){
          var onlyOnce = elt.getAttribute('data-reveal-onlyOnce') ? eval(elt.getAttribute('data-reveal-onlyOnce')) : false;
          var threshold = elt.getAttribute('data-reveal-threshold') ? parseFloat(elt.getAttribute('data-reveal-threshold')) : .15;
          if(isMobileTabletContext) {
            threshold = threshold / 4;
          }
          XXL.XLObserver(elt, animRevealCallback, threshold, onlyOnce);
        });
      }*/
    };
		
		//wait for page to be fully loaded 
		window.addEventListener('load', function () {
			//console.log("document loaded");
      if(locoScroll) {
        locoScroll.update();
      }
      moreAction();
      //calculate vh for mobile
      calculateVhForMobiles();
		});
		
		//resizeEnd
		window.addEventListener('resizeEnd', function() {
			windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
			windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
			isMobileContext = (windowWidth < mobileLimit) ? true : false;
			isMobileTabletContext = (windowWidth < tabletLimit) ? true : false;
			isTabletContext = (windowWidth < tabletLimit) && (windowWidth > mobileLimit)? true : false;
      if(locoScroll) {
        locoScroll.update();
      }
      if(isPrevMobileTabletContext != isMobileTabletContext) {
        initLocomotive();
      }
      initFilters();
      updateDefaultSliders();
      //calculate vh for mobile
      calculateVhForMobiles();
      isPrevMobileContext = isMobileContext;
      isPrevMobileTabletContext = isMobileTabletContext;
      isPrevTabletContext = isTabletContext;
		});
    
    //scrollEnd
    window.addEventListener('scrollEnd', function() {
      //console.log("scrollEnd");
      calculateVhForMobiles();
    });

    
    function updateTargetAttribute(){
      var externalRegex = new RegExp('/' + window.location.host + '/');
      document.querySelectorAll('a').forEach(function(el) {
        if(!externalRegex.test(el.href) && el.href.indexOf('http') === 0) {
          el.setAttribute("target", "_blank");
        }
      });
    };
    
    function updateExternalPicto(){
      document.querySelectorAll('a:not([class]').forEach(function(el) {
        if(el.getAttribute('target') === '_blank') {
          var picto = document.createElement('span');
          //picto.setAttribute('style', 'width:2.3rem');
          picto.classList.add('external-picto');
          picto.innerHTML = '<svg viewBox="0 0 23 23"><use xlink:href="#svg-external-link-picto"></use></svg>';
          el.append(picto);
        }
      });
    };
    
    function initApp() {
      //console.log("initApp()");
      initLocomotive();
      initAnimReveal();
      initDefaultSliders();
      initPressSliders();
      initImagesSliders();
      initEventsSliders();
      initAccordions();
      moreAction();
      initFilters();
      updateTargetAttribute();
      updateExternalPicto();
      setVisuWidth();
      //initRegalParallax();
    }
    initApp();
    XXL.initApp = initApp;
	});
})();
